var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NotificationContainer'),(_vm.auth.appLoading)?_c('AppLoading'):_vm._e(),(_vm.loader.blockingLoader)?_c('AppLoading'):_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }